import * as Yup from 'yup';

export const canaisComercializacaoValidationSchema = Yup.object().shape({
    canaisSelecionados: Yup.array().min(1, 'Selecione pelo menos um canal.'),
    outroTexto: Yup.string().when('canaisSelecionados', {
        is: (canais: string[]) => canais.includes('OUTRO'),
        then: (schema: any) => schema.required('Descreva o canal "OUTRO".'),
    }),
});

export default canaisComercializacaoValidationSchema;
